import React from 'react'
import styled from 'styled-components'

import CloseBtnIcon from '../assets/REDESIGN_Assets/MainScreen/close-btn-promo.svg'

const GenericCloseButton = styled.button`
  border: none;
  background-color: transparent;
  display: block;
  position: absolute;
  right: ${(props) => (props.right ? props.right : '3%')};
  top: ${(props) => (props.top ? props.top : '3%')};
  width: ${(props) => (props.width ? props.width : '32px')};
  height: ${(props) => (props.height ? props.height : '32px')};
  transition: transform 0.35s ease-in-out;
  z-index: 14;

  &:hover {
    transform: rotate(180deg);
  }

  &:before {
    content: '';
    position: absolute;
    display: block;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: ${(props) => (props.width ? props.width : '32px')};
    height: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.5);
    transform: rotate(45deg);
    transform-origin: center;
  }
  &:after {
    content: '';
    position: absolute;
    display: block;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: ${(props) => (props.width ? props.width : '32px')};
    height: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.5);
    transform: rotate(-45deg);
    transform-origin: center;
  }

  &.promo-modal-close-btn {
    width: 20px;
    height: 20px;
    &:after {
      display: none;
    }
    &:before {
      display: none;
    }

    &.info {
      width: 15px;
      height: 15px;
      right: 15px;
      top: 10px;
    }

    background: url(${CloseBtnIcon});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
`
export default GenericCloseButton
